import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Phone, Mail, Facebook, Instagram, Linkedin, MapPin } from 'lucide-react';
export function Contact() {
  return <Section id="contact" background="dark" className="relative" data-id="element-44">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-45">
        {/* Contact Info */}
        <div data-id="element-46">
          <h4 className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-47">
            Get In Touch
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-48">
            Ready to Find Your Next Home?
          </h2>
          <p className="text-gray-400 text-lg mb-10 max-w-md" data-id="element-49">
            Whether you're buying, selling, or investing — let's connect and
            discuss your real estate goals.
          </p>

          <div className="space-y-6" data-id="element-50">
            <div className="flex items-start space-x-4" data-id="element-51">
              <div className="bg-brand-gold/10 p-3 rounded-full" data-id="element-52">
                <Phone className="w-6 h-6 text-brand-gold" data-id="element-53" />
              </div>
              <div data-id="element-54">
                <p className="text-sm text-gray-400 uppercase tracking-wide" data-id="element-55">
                  Phone
                </p>
                <a href="tel:+14805550123" className="text-xl font-medium text-white hover:text-brand-gold transition-colors" data-id="element-56">
                  (480) 555-0123
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-57">
              <div className="bg-brand-gold/10 p-3 rounded-full" data-id="element-58">
                <Mail className="w-6 h-6 text-brand-gold" data-id="element-59" />
              </div>
              <div data-id="element-60">
                <p className="text-sm text-gray-400 uppercase tracking-wide" data-id="element-61">
                  Email
                </p>
                <a href="mailto:donavan@teamlehmanaz.com" className="text-xl font-medium text-white hover:text-brand-gold transition-colors" data-id="element-62">
                  donavan@teamlehmanaz.com
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-63">
              <div className="bg-brand-gold/10 p-3 rounded-full" data-id="element-64">
                <MapPin className="w-6 h-6 text-brand-gold" data-id="element-65" />
              </div>
              <div data-id="element-66">
                <p className="text-sm text-gray-400 uppercase tracking-wide" data-id="element-67">
                  Office
                </p>
                <p className="text-xl font-medium text-white" data-id="element-68">
                  Realty One Group
                  <br data-id="element-69" />
                  Gilbert, AZ
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 flex space-x-4" data-id="element-70">
            <a href="#" className="p-3 bg-white/5 hover:bg-brand-gold hover:text-white text-gray-400 rounded-full transition-all" data-id="element-71">
              <Facebook className="w-5 h-5" data-id="element-72" />
            </a>
            <a href="#" className="p-3 bg-white/5 hover:bg-brand-gold hover:text-white text-gray-400 rounded-full transition-all" data-id="element-73">
              <Instagram className="w-5 h-5" data-id="element-74" />
            </a>
            <a href="#" className="p-3 bg-white/5 hover:bg-brand-gold hover:text-white text-gray-400 rounded-full transition-all" data-id="element-75">
              <Linkedin className="w-5 h-5" data-id="element-76" />
            </a>
          </div>
        </div>

        {/* Form */}
        <div className="bg-white p-8 md:p-10 rounded-sm shadow-2xl" data-id="element-77">
          <h3 className="text-2xl font-bold text-brand-dark mb-6" data-id="element-78">
            Send a Message
          </h3>
          <form className="space-y-6" data-id="element-79">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-80">
              <div data-id="element-81">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-82">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-brand-gold focus:ring-1 focus:ring-brand-gold outline-none transition-all" placeholder="Your Name" data-id="element-83" />
              </div>
              <div data-id="element-84">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-85">
                  Phone
                </label>
                <input type="tel" id="phone" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-brand-gold focus:ring-1 focus:ring-brand-gold outline-none transition-all" placeholder="(555) 123-4567" data-id="element-86" />
              </div>
            </div>
            <div data-id="element-87">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-88">
                Email
              </label>
              <input type="email" id="email" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-brand-gold focus:ring-1 focus:ring-brand-gold outline-none transition-all" placeholder="you@example.com" data-id="element-89" />
            </div>
            <div data-id="element-90">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-91">
                Message
              </label>
              <textarea id="message" rows={4} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-brand-gold focus:ring-1 focus:ring-brand-gold outline-none transition-all resize-none" placeholder="How can I help you?" data-id="element-92"></textarea>
            </div>
            <Button fullWidth size="lg" className="mt-2" data-id="element-93">
              Send Message
            </Button>
          </form>
        </div>
      </div>
    </Section>;
}